<div class="information-screen">
  <h2>{{ 'Intellitrailer.LocationPermissionInfo.Title' | translate : 'Enable location services'}}</h2>

  <mat-icon>location_on</mat-icon>
  <br />
  <b>{{'Intellitrailer.LocationPermissionInfo.SubTitle' | translate : 'We need your location to unlock.' }}</b>
  <p>{{ 'Intellitrailer.LocationPermissionInfo.Text' | translate : 'In order to determine that you are at the correct location for pickup/return of the trailer and to connect to the bluetooth lock we need to access your location. This information is not stored in any way.'}}</p>
  @if(!permissionAsked) { <button mat-raised-button (click)="askForPermission()">{{ 'Intellitrailer.LocationPermissionInfo.cmdAskPermission' | translate : 'I understand' }}</button>}
  @if(permissionAsked) { <button mat-raised-button (click)="openSettings()">{{ 'Intellitrailer.LocationPermissionInfo.cmdOpenSettings' | translate : 'Open settings' }}</button> }
</div>
